module.exports = __webpack_public_path__ + "static/media/banner_cap6_prox.b0827584.jpg";